/**
 * Single point for reading an environment value.
 *
 * `config.js` is generated by `docker-entrypoint.sh` at container start and
 * populates `window.RUNTIME_CONFIG` before the bundle loads, so a deployment can
 * change any `REACT_APP_*` value without a rebuild. Values baked in by CRA at
 * build time are the fallback.
 *
 * Production images are built without any `REACT_APP_*` present, so for most
 * keys `window.RUNTIME_CONFIG` is the only layer that carries a value.
 */
export const getRuntimeEnv = (key: string): string | undefined => {
  const runtimeValue =
    typeof window !== 'undefined' ? window?.RUNTIME_CONFIG?.[key] : undefined

  return runtimeValue ?? process.env[key]
}
